import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=3b5bc0fb&scoped=true&"
import script from "./downloader.vue?vue&type=script&lang=js&"
export * from "./downloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bc0fb",
  null
  
)

export default component.exports